import styled from 'styled-components'

export const ContentContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
`

export const EmptyState = styled.div`
  text-align: center;
`

export const ActionsContainer = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;
`
